SelectBox = App.loadClass 'core::SelectBox'

class exports.Contracts_Edit_Handler extends Handler

    init: () ->
        @layoutUrl = 'backend/portal/contracts/load-layout-edit'
        @layoutSelector = App.sidebar.contentDiv().find('#edit')

        @msgwriter = @layoutSelector.find('.sidebar_message_writer')
        @msgwriter.message_writer()
        @msgwriter.message_writer 'info', 'Loading Contracts...'

        @loadLayout()

    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        ths = this

        @msgwriter.message_writer 'success', 'Contracts Loaded'
        @msgwriter.message_writer 'hide'

        $('#contract_edit_year').bind 'change', () =>
            @parent.filterParams = {}
            @filterSelects()

        $('#contract_edit_grower').bind 'change', () =>
            @parent.filterParams = {}
            $('#contract_edit_field').val('')
            @filterSelects()

        $('#contract_edit_field').bind 'change', () =>
            @parent.filterParams = {}
            @filterSelects()

        # Contract Select
        $('#contract_edit_number').bind 'change', () ->
            ths.parent.loadContract($(this).val())

        # if @parent.filterParams
        #     console.log('Load object:')
        #     console.log(@parent.filterParams)
        #     console.log('loading year')
        #     $('#contract_edit_year').val(@parent.filterParams.year)
        #     console.log('parent: '+@parent.filterParams.year+' val: '+$('#contract_edit_year').val())
        #     console.log('loading uid')
        #     # $('#contract_edit_grower option').each(()->
        #     #     console.log('val: '+$(this).val()))
        #     $('#contract_edit_grower').val(@parent.filterParams.uid)
        #     console.log('parent: '+@parent.filterParams.uid+' val: '+$('#contract_edit_grower').val())
        #     console.log('loading fid')
        #     $('#contract_edit_field').val(@parent.filterParams.fid)
        #     console.log('parent: '+@parent.filterParams.fid+' val: '+$('#contract_edit_field').val())
        # $('#contract_edit_year').change()
        @filterSelects()


    filterSelects: () ->
        year = $('#contract_edit_year').val()
        uid = $('#contract_edit_grower').val()
        fid = $('#contract_edit_field').val()

        if (jQuery.isEmptyObject(@parent.filterParams))
            params = {}
            params.year = year if year
            params.uid = uid if uid
            params.fid = fid if fid
            @parent.filterParams = params
        else
            params = @parent.filterParams
            params.reload = true

        $.post 'backend/portal/contracts/list-contracts', params, (json) =>

            json    = json.data
            SelectBox.render SelectBox.prepareObject(json.growers), $('#contract_edit_grower') if json.growers
            SelectBox.render SelectBox.prepareObject(json.fields), $('#contract_edit_field') if json.fields
            SelectBox.render SelectBox.prepareObject(json.contracts), $('#contract_edit_number')


            if $('#contract_edit_number').find('option').length is 1
                $('#contract_edit_number').html('<option value="">No Contracts</option>')

            if not jQuery.isEmptyObject(@parent.filterParams)
                if @parent.filterParams.year and $('#contract_edit_year').val() isnt @parent.filterParams.year
                    $('#contract_edit_year').val(@parent.filterParams.year)
                if @parent.filterParams.uid and $('#contract_edit_grower').val() isnt @parent.filterParams.uid
                    $('#contract_edit_grower').val(@parent.filterParams.uid)
                if @parent.filterParams.fid and $('#contract_edit_field').val() isnt @parent.filterParams.fid
                    $('#contract_edit_field').val(@parent.filterParams.fid)


    sort: (elem) ->
        oldval = elem.val()

        arr = elem.find('option[value!=""]').sort(@selectSort)
        elem.empty().prepend('<option value="">Select...</option>').append arr

        elem.val(oldval)


    selectSort: (a, b) ->
        if a.text > b.text
            return 1
        else if a.text < b.text
            return -1
        return 0
